import { render, staticRenderFns } from "./uploadEntrust.vue?vue&type=template&id=35cb559e&scoped=true"
import script from "./uploadEntrust.vue?vue&type=script&lang=js"
export * from "./uploadEntrust.vue?vue&type=script&lang=js"
import style0 from "./uploadEntrust.vue?vue&type=style&index=0&id=35cb559e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb559e",
  null
  
)

export default component.exports